import React from 'react'

import Attachment from "../../../model2/attachment/attachment"
import {AttachFileMode} from "../const"
import AttachmentView from "../attachment-view/attachment-view"
import {AttachmentSystemType} from "../../../model2/attachment/@types"

type Props = {
    attachments             : any // object ? Attachment models ?
    hiddenAttachmentsIds    : any[]
    mode                    : AttachFileMode
    onPreview?              : callback
    onAddToMessage?         : callback
    onRemove?               : callback
    className?              : string
}

// const debug = "AttachmentsListByType"
const debug = false

export default class AttachmentsListByType extends React.Component<Props> {

    static defaultProps = {
        hiddenAttachmentsIds: []
    }

    constructor(props:Props) {
        super(props);
    }

    onPreview = (attachment:Attachment) => {
        debug && console.log(debug, "onPreview() attachment=", attachment)
        if (this.props.onPreview) {
            this.props.onPreview(attachment)
        } else {
            gd.attachments.preview(attachment, this.props.attachments);
        }
    }

    render() {
        const {attachments} = this.props

        if (attachments.isEmpty) {
            return null
        }

        const withPreview = attachments.withPreviewAndNotInMessage
        let withoutPreview: Attachment[] = []

        if(this.props.attachments.models[0]?.systemType === AttachmentSystemType.CUSTOM) {
            withoutPreview = attachments.allAttachments
        } else {
            withoutPreview = attachments.withoutPreviewAndNotInMessage
        }

        const showAttachmentsWithPreview    = !_.isEmpty(withPreview) && this.props.attachments.models[0]?.systemType !== AttachmentSystemType.CUSTOM
        const showAttachmentsWithoutPreview = !_.isEmpty(withoutPreview)

        const withoutPreviewClasses = Classes("ui5-attachments-list flex-gap-15", {
            'm-t-15': showAttachmentsWithPreview
        })

        return (
            <div className={this.props.className}>
                {showAttachmentsWithPreview &&
                    <div className="ui5-attachments-list flex-gap-15">
                        {_.map(withPreview, (attachment:Attachment)=>{
                            return (
                                <AttachmentView
                                    key             = {attachment.fileId}
                                    attachment      = {attachment}
                                    onPreview       = {this.onPreview}
                                    onRemove        = {this.props.onRemove}
                                    onAddToMessage  = {this.props.onAddToMessage}
                                    mode            = {this.props.mode}
                                />
                            )
                        })}
                    </div>}

                {showAttachmentsWithoutPreview &&
                    <div className={withoutPreviewClasses}>
                        {_.map(withoutPreview, (attachment: Attachment)=>{
                            return (
                                <AttachmentView
                                    key             = {attachment.fileId}
                                    attachment      = {attachment}
                                    onPreview       = {this.onPreview}
                                    onRemove        = {this.props.onRemove}
                                    onAddToMessage  = {this.props.onAddToMessage}
                                    mode            = {this.props.mode}
                                />
                            )
                        })}
                    </div>}
            </div>
        )
    }
}
